export default function getParams() {
  const splitParams = window.location.search.slice(1).split('&');
  return splitParams.reduce((parameters, item) => {
    const [key, value = true] = item.split('=');
    return {
      ...parameters,
      [key]: value,
    };
  }, {});
}
